import { Component, Input } from '@angular/core';
import { DynamicProperties, MemberDto } from '../../../../../service/dto';

@Component({
  selector: 'app-member-view-details',
  standalone: false,
  templateUrl: './member-view-details.component.html',
  styleUrl: './member-view-details.component.scss'
})
export class MemberViewDetailsComponent {
	@Input() member!: MemberDto;

	getDynamicProperties(properties: DynamicProperties): string[]{
		return Object.keys(this.member.properties);
	}
}
